import { render, staticRenderFns } from "./vrCorporateLedgerComponent.vue?vue&type=template&id=289997a5&"
import script from "./vrCorporateLedgerComponent.vue?vue&type=script&lang=js&"
export * from "./vrCorporateLedgerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports